﻿import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";

@Component({
	selector: 'form-case-send-investor',
	templateUrl: './form-case-send-investor.component.html',
	styleUrls: ['./form-case-send-investor.component.scss']
})
export class FormCaseSendInvestorComponent implements OnInit {

  @Output()
  callbackRegister = new EventEmitter();
  @Input()
  data: any;

  constructor() {
    this.isValid = this.isValid.bind(this);
  }

  ngOnInit() {
    this.data.sentInvestorDate = this.data.sentInvestorDate || new Date();

    this.callbackRegister.emit({
      isValid: this.isValid,
    });
  }

  isValid() {
    return !!this.data.sentInvestorDate;
  }
}
